import { useState } from "react";
import { useGeneric } from "../useGeneric";
import { InvoiceMetadataType, InvoiceType } from "./InvoiceMetadataType";
import Loading from "../main/Loading";
import { KsefInvoice } from "./InvoiceType";
import SystemInvoice from "./SystemInvoice";

export default function KsefInvoiceMapper({
  invoiceMetaData,
}: {
  invoiceMetaData: InvoiceMetadataType;
}) {
  const [updates, setUpdates] = useState(0);
  const { customer, loading: loadingCustomer }: any = useGeneric({
    name: "get-client-by-nip",
    update: updates,
    query: {
      nip: invoiceMetaData?.seller?.nip,
      //7123211198
    },
  });
  const { invoiceData, loading }: any = useGeneric({
    name: "get-ksef-invoice",
    update: updates,
    query: {
      ksef: invoiceMetaData?.ksefNumber,
    },
  });

  const invoice: KsefInvoice = invoiceData;
  console.log(invoice);

  return (
    <div>
      {loading ? (
        <Loading variant={1} text={"Pobieranie faktury z KSeF"} />
      ) : (
        <></>
      )}
      <div className="invoice-mapping-form table-details">
        <div className="details-prop-group">
          <div className="details-prop-name">Nr KSeF</div>
          <div className="details-prop-value">
            {invoiceMetaData?.ksefNumber}
          </div>
        </div>
        <div className="details-prop-group">
          <div className="details-prop-name">Sprzedający</div>
          <div className="details-prop-value">
            {invoiceMetaData?.seller?.name}
          </div>
        </div>
        <div className="details-prop-group">
          <div className="details-prop-name">NIP</div>
          <div className="details-prop-value">
            {invoiceMetaData?.seller?.nip}
          </div>
        </div>
        <div className="details-prop-group">
          <div className="details-prop-name">AdresL1</div>
          <div className="details-prop-value">
            {invoice?.Podmiot1?.Adres?.AdresL1}
          </div>
        </div>
        <div className="details-prop-group">
          <div className="details-prop-name">AdresL2</div>
          <div className="details-prop-value">
            {invoice?.Podmiot1?.Adres?.AdresL2}
          </div>
        </div>
      </div>
      <div>
          <SystemInvoice />
        </div>
    </div>
  );
}
